import { forwardRef } from 'react';

import AppContainerLayout from '#/layouts/AppContainerLayout';

const MainLayout = forwardRef<HTMLDivElement, MainLayoutProps>(({ children, leftPage }, ref) => {
  return (
    <AppContainerLayout ref={ref}>
      <div className="flex divide-x">
        <div className="w-[410px] 2xl:w-[450px]">
          <div className="sticky top-0 h-screen pr-1 overflow-y-auto">{leftPage}</div>
        </div>
        <div className="flex-1 px-5">{children}</div>
      </div>
    </AppContainerLayout>
  );
});
export type MainLayoutProps = {
  children: React.ReactNode;
  leftPage: React.ReactNode;
};

export default MainLayout;
